<template>

  <RiepilogoPagamenti />
 
</template>

<script>
import RiepilogoPagamenti from '../components/pratiche/RiepilogoPagamenti.vue'

export default {
  pageName: '',
  components: {
    RiepilogoPagamenti

  },
  data() {
    return {

    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },

  methods: {
    
  },
}
</script>
